import {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import { memberApi, reservationApi } from "../api";

const AdminDataContext = createContext(null);

export const AdminDataProvider = ({ children }) => {
  const [members, setMembers] = useState([]);
  const [reservations, setReservations] = useState([]);

  const [loading, setLoading] = useState(true);

  // ── Fetch all data from API ─────────────────────────────────────────────
  // const fetchAll = useCallback(async () => {
  //   setLoading(true);
  //   try {
  //     const [b, n, c] = await Promise.all([
  //       memberApi.getAll(),
  //       //reservationApi.getAll(),
  //     ]);
  //     setMembers(Array.isArray(b) ? b : []);
  //     setReservations(Array.isArray(n) ? n : []);
  //   } catch (err) {
  //     console.warn("API fetch failed:", err.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // }, []);

  // useEffect(() => {
  //   fetchAll();
  // }, [fetchAll]);

  // ── Member ───────────────────────────────────────────────────────────────

  const deleteMember = async (id) => {
    await memberApi.remove(id);
    setMembers((prev) => prev.filter((b) => b.id !== id));
  };

  // ── Reservation ───────────────────────────────────────────────────────

  const deleteReservation = async (id) => {
    await reservationApi.remove(id);
    setReservations((prev) => prev.filter((n) => n.id !== id));
  };

  return (
    <AdminDataContext.Provider
      value={{
        loading,

        members,
        deleteMember,
        reservations,
        deleteReservation,
      }}
    >
      {children}
    </AdminDataContext.Provider>
  );
};

export const useAdminData = () => {
  const ctx = useContext(AdminDataContext);
  if (!ctx)
    throw new Error("useAdminData must be used inside AdminDataProvider");
  return ctx;
};
